<template>
	<div class="dia">
		<el-dialog :destroy-on-close="true" :visible.sync="authorizeDialog" width="35%" :before-close="close">
			<div slot="title" class="title">授权</div>
			<div>
				<el-form size="small" :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position="top">
					<el-form-item label="角色名" prop="title"><el-input readonly v-model="ruleForm.title"></el-input></el-form-item>
					<el-form-item label="分配节点">
						<el-tree
							:data="data"
							show-checkbox
							node-key="id"
							:default-checked-keys="checkedArr"
							:default-expanded-keys="checkedArr"
							@check="setCheckedNodes"
							:props="defaultProps"
						></el-tree>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="small-btn btn-bor" size="small" @click="close">取 消</el-button>
				<el-button class="small-btn bgC" size="small" type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: {
		disabled: {
			type: Boolean,
			default() {
				return false;
			}
		},

		accountObj: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			isClick: false,
			id: '',
			submitArr: [],
			checkedArr: [],
			authorizeDialog: false,
			defaultProps: {
				children: 'children',
				label: 'title'
			},
			data: [],
			ruleForm: {
				title: ''
			}
		};
	},
	methods: {
		setCheckedNodes(e1, e2) {
			console.log(e1, e2);
			this.isClick = true;
			this.submitArr = e2.checkedKeys.concat(e2.halfCheckedKeys);
		},
		//   提交按钮
		submitForm(formName) {
			let obj = {
				id: this.id,
				node: '[' + this.submitArr + ']',
				isClick: this.isClick
			};
			this.$emit('saveAuthorize', obj);
		},
		//   关闭弹框
		close() {
			this.authorizeDialog = false;
			this.$refs['ruleForm'].resetFields();
		}
	}
};
</script>

<style lang="scss" scoped="scoped">
.dia /deep/ {
	.el-dialog .el-dialog__body {
		max-height: 55vh;
		overflow: auto;
	}
}

.title {
	text-align: left;
}
.el-form-item__label {
	padding: 0 !important;
}
.el-form-item {
	margin-bottom: 0 !important;
	padding: 5px 30px;
}
.el-dialog__body {
	padding-top: 10px;
}
.el-dialog {
	border-radius: 8px;
}
.el-dialog__footer {
	padding-top: 0;
	text-align: center;
}
.small-btn:hover {
	opacity: 0.8 !important;
}
.small-btn:active {
	opacity: 0.9 !important;
}
</style>
